import React from 'react'
import PropTypes from 'prop-types'
import { Container, Segment, Header, Icon, List } from 'semantic-ui-react'

const propTypes = {
  /**
   * HTTP ステータスコード
   */
  statusCode: PropTypes.number.isRequired,

  /**
   * アイコン名（Semantic UI）
   */
  icon: PropTypes.string.isRequired,

  /**
   * 見出し
   */
  title: PropTypes.string.isRequired,

  /**
   * 想定される原因
   */
  reasons: PropTypes.arrayOf(PropTypes.string),

  /**
   * 次に取ってほしい行動
   */
  action: PropTypes.string,
}

const defaultProps = {
  reasons: [],
  action: null,
}

/**
 * エラーページの共通レイアウト
 */
const ErrorPage = ({ statusCode, icon, title, reasons, action }) => (
  <Container text>
    <Segment basic padded="very" textAlign="center">
      <Header as="h2" icon color="grey">
        <Icon name={icon} />
        {title}
        <Header.Subheader>エラーコード: {statusCode}</Header.Subheader>
      </Header>

      {reasons.length > 0 && (
        <Segment textAlign="left">
          <p>次のような原因が考えられます。</p>
          <List bulleted items={reasons} />
        </Segment>
      )}

      {action && <p>{action}</p>}
    </Segment>
  </Container>
)

ErrorPage.propTypes = propTypes
ErrorPage.defaultProps = defaultProps

export default ErrorPage
